<template>
    <div class="filter">
        <div class="row">
            <div class="col-md-3 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label class="control-label text required" ><abbr title="Obligatorio">*</abbr>Nombre: </label>
                    <input type="text" v-model="r.name"  class="form-control">
                </div>
            </div>
            <div class="col-md-3 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="name"><abbr title="Obligatorio">*</abbr>Código: </label>
                    <input type="text" v-model="r.code"  class="form-control required">
                </div>
            </div>
        </div>
        <div class="input-group-btn">
            <button class="btn btn-success" v-on:click="modifyCurrency()">Aceptar</button>
        </div>
    </div>
</template>



<script>
    export default {
        props: ['r', 'history'],
        methods: {
            modifyCurrency() {
                if (this.r.id != null){
                    this.$http.put('/admin/hotel_plans/'+this.r.id, {hotel_plan: this.r}).then(response => {
                        Turbolinks.visit('/admin/hotel_plans/' + response.body.id)
                    }, response=> {
                        console.log(response);
                        }
                    )
                }

            }
        },
        data: function () {
            return {currency: 'r' }
        }
    }
</script>